










































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';

const StaffAction = namespace('desk/staff').Action;
const StaffGetter = namespace('desk/staff').Getter;

const CommGetter = namespace('desk/comm').Getter;

export interface TargetEditType { // 编辑结构类型
  period: string | null; // 周期展示
  user_id: number[]; // 用户ids
  project_id: number | null; // 项目id
  target_period: number | null; // 周期
  target_type: number | null; // 类型
  target_num: number | null; // 目标数
}

@Component({
  components: {
    AcgnPop
  }
})

/**
 * 目标进度
 */
export default class TargetEdit extends Vue {
  public name: string = 'TargetEdit';

  @Prop({ type: Object, default: {} }) private data: TargetEditType; // 数据
  @Prop({ type: Boolean, default: false }) private visible: boolean; // 控制dialog显示

  @StaffAction private updateStaffTarget: any; // 更新员工目标
  @StaffAction private setStaffTarget: any; // 设定员工目标

  @StaffGetter private loadings: any; // 章节loading
  @CommGetter private attributeData: any; // 公共类型

  private formData: TargetEditType = {
    period: '',
    user_id: [], // 用户id
    project_id: null, // 项目id
    target_period: null, // 周期
    target_type: null, // 类型
    target_num: null // 目标数
  };
  private editTypes: any = {
    1: '批量设定目标',
    2: '批量修改目标',
    3: '设定目标',
    4: '修改目标'
  };

  // 周期
  private get targets() {
    return this.attributeData.user_target.target_period;
  }

  // 类型
  private get types() {
    return this.attributeData.user_target.target_type;
  }

  private get isEdit() {
    return [2, 4].includes((this.data as any).type);
  }
  private get title() {
    return this.editTypes[(this.data as any).type];
  }
  private get show() {
    return this.visible;
  }
  private set show(v) {
    this.$emit('update:visible', v);
  }
  // 获取表单验证规则
  private get rules() {
    const rules = {
      target_period: [
        { required: true, message: '请选择目标周期', trigger: 'change' }
      ],
      target_type: [
        { required: true, message: '请选择目标类型', trigger: 'change' }
      ],
      target_num: [
        { required: true, message: '请输入目标数', trigger: 'blur' }
      ]
    };
    return rules;
  }

  private async created() {
    this.formData = { ...this.formData, ...(this.data as any).data };
  }

  // 收费设置提交
  private async submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const postData = complexClone(this.formData);
        if (this.isEdit) {
          await this.updateStaffTarget(postData);
        } else {
          await this.setStaffTarget(postData);
        }

        this.$emit('change');
        this.$message.success('保存成功');
        this.show = false;
      } catch (ex) {
        this.$message.error(this.$language.error);
      }
    });
  }

  // 取消
  private close() {
    this.show = false;
  }
}
